import React, { useState, useEffect } from "react";
import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  EditButton,
  TextField,
  ImageField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  BooleanField,
  EmailField,
  NumberField,
  useTranslate,
  useGetOne,
  useResourceContext,
  useRecordContext,
  DeleteButton,
  useListContext,
  Button,
  Link,
  Pagination,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  GetCurrentUserRoles,
} from "../common/common";
import { OrderStatus } from "../loyaltyWithReward/common";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

const apiUrl = RUN_TIME_API_ENDPOINT;

const ListingModal = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     const [open, setOpen] = useState(false);
  //     const [userId, setUserId] = useState(1);
  //   };
  // }
  console.log("propspropsprops", props);
  const location = useLocation();
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const [userId, setUserId] = useState(1);

  useEffect(() => {
    console.log("callllllllled", location);
    // Update the document title using the browser API
    let _paramsUrl = location.pathname.split("/");
    console.log("_paramsUrl", _paramsUrl);

    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      console.log("params found", _paramsUrl[2]);
      setUserId(_paramsUrl[2]);
    }
  }, []);

  // componentDidMount() {
  //   let _paramsUrl = window.location.href.split("/");
  //   if (_paramsUrl.length > 1 && _paramsUrl[5] !== "") {
  //     console.log("params found", _paramsUrl[5]);
  //     this.setState({ userId: _paramsUrl[5] });
  //   }
  // }

  const onSave = (record) => {
    console.log(
      "user_entity_mapping_status",
      record.user_entity_mapping_status
    );
    const url = `${apiUrl}/user_entity_mappings/${userId}/businesses/${record.id}`;
    const data = {
      status: String(!JSON.parse(record.user_entity_mapping_status)),
      id: record.id,
      ids: record.ids,
    };
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify(data);
    console.log(data);
    Swal.fire({
      text: "Please wait while your request is being processed.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    return fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json);
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const openListingModal = () => {
    let _paramsUrl = window.location.href.split("?");
    if (_paramsUrl.length > 1 && _paramsUrl[1] !== "") {
      console.log("params found", _paramsUrl);
    }
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(true);
  };

  const onToggle = () => {
    console.log("user_entity_mapping_status", record);
    let settingValue =
      record.user_entity_mapping_status !== true ? "ON" : "OFF";
    Swal.fire({
      text:
        "Are you sure to change the value of " +
        record.user_entity_mapping_status +
        " to " +
        settingValue +
        ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        onSave(record);
      }
    });
  };

  let recordValue = record.user_entity_mapping_status ? "ON" : "OFF";
  let settingValue = record.user_entity_mapping_status !== true ? "ON" : "OFF";
  console.log("provvvvvvvvvvvps", record);
  return (
    <div>
      <div
        className={`toggle-button-container ${
          recordValue === "ON" ? "toggle-button-on" : ""
        }`}
      >
        <label className="switch">
          <input
            type="checkbox"
            checked={recordValue === "ON"}
            onChange={openListingModal}
          />{" "}
          <div></div>
        </label>
        <span className="switch-status">{recordValue}</span>
      </div>
      {open && onToggle()}
    </div>
  );
};

const CustomEditButton = ({ record, basePath }) => {
  console.log("custom show", record, basePath);
  const { data } = useGetOne("users", { id: record?.id });
  return (
    <div>
      <EditButton to={`${basePath}/${record?.id}`} />
    </div>
  );
};

const CreateLoyaltyPoint = ({ resource, record }) => {
  console.log("record create loyalty points", resource, record);
  const translate = useTranslate();

  return (
    <Button
      className="custom-button create-sdo"
      component={Link}
      to={{
        pathname: `/user_loyalty_points/create`,
        state: { id: record?.id },
      }}
    >
      <span>+ {translate("resources.users.fields.create_loyalty_points")}</span>
    </Button>
  );
};

const ShowActions = () => {
  const userLocale = getLocalStorageKey("locale");
  const record = useRecordContext();
  console.log("record", record);
  const resource = useResourceContext();
  let roleData = GetCurrentUserRoles();
  console.log("roleData", roleData);

  return (
    <TopToolbar className="toolbar-center-align">
      <RefreshButton />
      {
        userLocale == "en-GB" &&
        <CreateLoyaltyPoint resource={resource} record={record} />
      }
      <ListButton basePath={resource} />
      <EditButton basePath={resource} record={record} id={record?.id} />
      {["$csa"].indexOf(roleData) === -1 && (
        <DeleteButton
          mutationMode="pessimistic"
          confirmTitle={
            "Delete user " + record?.first_name + " " + record?.last_name
          }
        />
      )}
    </TopToolbar>
  );
};

const ShowTitle = () => {
  const translate = useTranslate();
  const record = useRecordContext();
  return (
    record && (
      <span>
        {translate("resources.users.fields.user_test")} {record.first_name}
      </span>
    )
  );
};

const RoleName = (props) => {
  const record = useRecordContext();  
  return (
    <span>
      {/* {record?.role_name == undefined ? record?.role_name.replace(/_/g, " ") : "-"} */}
      {record?.role_name?.replace(/_/g, " ")}
    </span>
  );
};

const ClickItUserShow = ({ permissions, ...props }) => {
  const record = useRecordContext();
  const location = useLocation();
  const translate = useTranslate();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  console.log("props ==> userssss", businessIdVal);
  const { id } = props;
  const showAllOrders = getLocalStorageKey("show_all_orders");
  const userLocale = getLocalStorageKey("locale");

  const { data } = useGetOne("users", { id: businessIdVal });

  useEffect(() => {
    // const { location } = props;

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(`${apiUrl}/users/${businessIdVal}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
      });
  }, []);

  const ClearFiltersOnMount = () => {
    const { setFilters } = useListContext();

    useEffect(() => {
      setFilters({}, []);
    }, [setFilters]);

    return null;
  };

  const ClickItUserPagination = (props) => (
    <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
  );

  return (
    // <div>
    //   <text>hfghgjfjh</text>
    // </div>
    <Show actions={<ShowActions />} title={<ShowTitle />}>
      <TabbedShowLayout Class="tab-scroll">
        <Tab
          label={translate("resources.users.fields.user_details")}
          contentClassName="scrollTab"
        >
          <TextField source="first_name" />
          <TextField source="last_name" />
          <TextField source="address" />
          <EmailField source="email" />
          <TextField source="phone" />
          <ImageField source="profile_image_data" title="Profile Image" />
          <BooleanField source="is_tnc_accepted" />
          {/* <BooleanField source="is_super" /> */}
          {/* <TextField source="role_name" /> */}
          <RoleName label="Role name" source="role_description" />
          <BooleanField source="status" />
          <DateField
            source="tnc_accepted_at"
            label={translate("resources.users.fields.tnc_accepted")}
          />
          <DateField
            source="tnc_rejected_at"
            label={translate("resources.users.fields.tnc_rejected")}
          />
          {
            userLocale == "en-GB" &&
            <TextField source="balance_points" label="Points" />
          }
          <TextField source="updated_by_id" />
          <DateField source="updated_at" />
          <DateField source="created_at" />
        </Tab>

        <Tab label={translate("resources.users.fields.sold_to")}>
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: "created_at", order: "DESC" }}
            reference="businesses"
            source="id"
            target="user_id"
            className="tab-pagination"
          >
            <List
              className="tab-list"
              // {...props}

              filter={{ user_id: businessIdVal }}
              filterDefaultValues={{ user_id: businessIdVal }}
              // bulkActionButtons={false}
              sort={{ field: "created_at", order: "DESC" }}
              exporter={false}
              hasCreate={false}
              actions={false}
            >
              {/* <ClearFiltersOnMount /> */}
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                <TextField source="name" />
                {/* <TextField source="name_sap_code" /> */}
                {/* <TextField source="address" /> */}
                {/* <NumberField source="orders_not_invoiced_price" /> */}
                {/* <EmailField source="email" /> */}
                {/* <TextField source="phone" /> */}
                {/* <BooleanField source="tnc_accepted" title="tnc Accepted" /> */}
                {/* <NumberField source="sap_digital_order_balance" /> */}
                <TextField source="sap_code" />
                {/* <TextField source="total_credit_string" title="Total Credit" /> */}
                {/* <BooleanField
                  source="user_entity_mapping_status"
                  title="status"
                /> */}
                {/* <TextField source="user_name" /> */}
                {/* <DateField source="last_seen_at" /> */}
                <BooleanField source="is_ordering_blocked" />
                {/* <BooleanField source="is_sap_blocked" /> */}
                {/* <BooleanField source="is_sap_deleted" /> */}
                {/* <ListingModal
                  source="status"
                  label={translate("resources.users.fields.userEntity")}                /> */}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>

        <Tab label={translate("resources.users.fields.orders")}>
          <ReferenceManyField
            addLabel={false}
            label=""
            sort={{ field: "created_at", order: "DESC" }}
            reference={
              showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"
            }
            source="id"
            target="placed_order_user_id"
            className="tab-pagination"
          >
            <List
              className="tab-list"
              // {...props}
              filter={{ placed_order_user_id: businessIdVal }}
              filterDefaultValues={{ placed_order_user_id: businessIdVal }}
              // bulkActionButtons={false}
              sort={{ field: "created_at", order: "DESC" }}
              disableSyncWithLocation
              exporter={false}
              hasCreate={false}
              actions={false}
            >
              {/* <ClearFiltersOnMount /> */}
              <Datagrid
                rowClick="show"
                className="tab-data-grid"
                bulkActionButtons={false}
              >
                <DateField label="Order Date" source="creation_date" />
                <ReferenceField
                  label="Sold To Name"
                  source="business_id"
                  reference="businesses"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField>
                <TextField source="order_number" />
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                />
                <ExpectedDateField
                  // label="Expected Date"
                  source="delivery_date_from"
                />
                <TextField
                  // label="Local PO Note"
                  source="customer_ref_number"
                />
                <TextField
                  label="Order Status"
                  source="customer_order_status_desc"
                />
                <TextField source="business_site" label="Ship To Name" />
                {/* <ReferenceField
                  label="Ship To Name"
                  source="sap_business_site_id"
                  reference="sap_business_sites"
                  link="show"
                  allowEmpty
                >
                  <TextField source="name" />
                </ReferenceField> */}
                {permissions === "isSap" && (
                  <DateField label="Date 1st seen in LR" source="created_at" />
                )}
                {permissions === "isSap" && showAllOrders && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        {data?.role_name == "contract_person" && (
          <Tab label={translate("resources.users.fields.contract")}>
            <ReferenceManyField
              label=""
              addLabel={false}
              reference="get_user_contracts"
              source="id"
              target="user_id"
              className="tab-pagination"
            >
              <List
                // {...props}
                className="tab-list"
                sort={{ field: "created_at", order: "DESC" }}
                filterDefaultValues={{ user_id: businessIdVal }}
                exporter={false}
                actions={false}
                hasCreate={false}
              >
                <Datagrid
                  className="tab-data-grid"
                  bulkActionButtons={false}
                  rowClick={false}
                >
                  <TextField source="label" />
                  <TextField source="sap_code" />
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        )}
        {
          userLocale == "en-GB" &&
          <Tab label={translate("resources.users.fields.loyalty_points")}>
            <ReferenceManyField
              label=""
              addLabel={false}
              reference="user_loyalty_points"
              source="id"
              target="user_id"
              className="tab-pagination"
            >
              <List
                // {...props}
                className="tab-list"
                pagination={<ClickItUserPagination />}
                sort={{ field: "created_at", order: "DESC" }}
                filter={{ user_id: businessIdVal }}
                filterDefaultValues={{ user_id: businessIdVal }}
                exporter={false}
                actions={false}
                hasCreate={false}
              >
                {/* <ClearFiltersOnMount /> */}
                <Datagrid
                  className="tab-data-grid"
                  bulkActionButtons={false}
                  rowClick={false}
                >
                  <ReferenceField
                    label="User name"
                    source="user_id"
                    reference="users"
                    link="show"
                    allowEmpty
                  >
                    <TextField source="first_name" />
                  </ReferenceField>
                  <OrderStatus source="points" />
                  <TextField source="category" />
                  <TextField source="comments" />
                  <DateField source="expired_at" />
                  <DateField source="created_at" />
                  <DateField source="updated_at" />
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        }
      </TabbedShowLayout>
    </Show>
  );
};

export default ClickItUserShow;
